import style from "./colors.module.scss";

const colors = [
    { name: 'Blue', color: style.blue },
    { name: 'BlueGrey', color: style.blueGrey },
    { name: 'Orange', color: style.orange },
    { name: 'DarkWhite', color: style.darkWhite },
    { name: 'White', color: style.white },     
];

const colorPalette2 = [
    { name: 'Orange', color: style.orange },
    { name: 'White', color: style.white },     
];

export {colors};
export {colorPalette2};
